import React, { Component } from 'react';

class Row extends Component {
    render() {
        const { dataPreview, keyRow } = this.props
        return (
            <tr
                id='row-import-order'
                className={
                    ((keyRow % 2) !== 0 ? 'row-import-order-even' : null)
                    + (dataPreview.ResultType === 'Warning' ? ' type-warning' : ' type-error')
                    + (dataPreview.ResultType === 'OK' ? " type-success" : "")
                }
            >
                <td>{dataPreview.ResultType}</td>
                <td>{dataPreview.ErrorLine}</td>
                <td>{dataPreview.ChannelOrderId}</td>
                <td>{dataPreview.ErrorColumn}</td>
                <td>{dataPreview.ErrorDetail}</td>
            </tr>
        );
    }
}

export default Row;


// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-validate/Row.js